module.exports = __webpack_public_path__ + "img/case1.75c931f9.png";